import { type ServiceDTO } from 'ecosystem'
import { Box, CheckboxGroup, HStack, VStack } from '@chakra-ui/react'
import { GrandText } from 'ui'
import { MdWarning } from 'react-icons/md'
import { CheckoutCartService } from './CheckoutCartService'

interface CheckoutCartServicesProps {
  services: ServiceDTO[]
  onChange?: (serviceIds: string[]) => void
}

export const CheckoutCartServices = ({ services, onChange }: CheckoutCartServicesProps) => {
  return (
    <VStack
      align="stretch"
      borderRadius="sm"
      fontSize={{ base: 'xs', md: 'sm' }}
      py={4}
      gap={6}
      w="full"
    >
      <Box bg="status.warning2" p={2} w="full">
        <GrandText>Fler tjänster finns tillgängliga</GrandText>
      </Box>

      <HStack w="full">
        <MdWarning color="status.warning" size={18} />
        <GrandText>
          Serviceavgiften debiteras per vara, rabatter kan tillkomma om man lägger till mer än en
          vara av samma typ.
        </GrandText>
      </HStack>

      <CheckboxGroup onChange={onChange}>
        <VStack alignItems="stretch">
          {services.map((service) => (
            <CheckoutCartService
              key={service.id}
              checkboxProps={{
                value: service.id
              }}
              service={service}
            />
          ))}
        </VStack>
      </CheckboxGroup>
    </VStack>
  )
}
